<div class="image-viewer mt-4">
    <!-- <table class="title-bar">
        <tr>
            <td class="pl-2 font-medium">ROOM {{roomnumber}}</td>
            <td class="pl-2 font-medium">
                {{name}}
            </td>
            <td class="pl-2 font-medium">{{date | date:'MM.dd.YYYY - hh:mm:ss'}}</td>
        </tr>
    </table> -->
    <br>
    <img [ngClass]="{'fixed-width':!expanded, 'full-width': expanded}" [src]="url" alt="" (click)="onImageClick()">
</div>